export const ADD_DEVICE = {
  title: 'Add Device'
};
